import { NEED_MORE_INFO } from "../../shared/instantAnswerUtils";
import { getDeliveredAtDateFromIAContext } from "../../utils/getDeliveredAtDateFromIAContext";
import { orderCanBeReportedBasedOnDeliveryDate } from "../../utils/orderCanBeReportedBasedOnDeliveryDate";
import { GoToBrandReferralsCTA, GoToFairePosCTA, ReportItemsCTA, RequestExtensionCTA, VerifyAccountCTA, ViewInvoicesCTA, ViewOrUpdatePaymentMethodsCTA, ViewOrderInvoiceCTA } from "./ctas";
export var NEED_MORE_INFO_ANSWER = function NEED_MORE_INFO_ANSWER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return NEED_MORE_INFO(strictLocalize);
    },
    getDescription: function getDescription() {
      return [CHECKOUT_OUR_ARTICLES(strictLocalize)];
    }
  };
};
var CHECKOUT_OUR_ARTICLES = function CHECKOUT_OUR_ARTICLES(strictLocalize) {
  return strictLocalize({
    id: "cHcJWP",
    defaultMessage: [{
      "type": 0,
      "value": "Bekijk hieronder enkele aanbevolen artikelen uit ons Helpcentrum of neem contact met ons op als je meer hulp nodig hebt."
    }]
  });
};
export var INELIGIBLE_FOR_REPORT = function INELIGIBLE_FOR_REPORT(strictLocalize) {
  return strictLocalize({
    id: "cVWbfo",
    defaultMessage: [{
      "type": 0,
      "value": "De periode van 14 dagen voor het melden van beschadigde, ontbrekende of onjuiste artikelen voor deze bestelling is verstreken"
    }]
  });
};
export var DO_NOT_PROCESS_DAMAGED_AS_RETURN = function DO_NOT_PROCESS_DAMAGED_AS_RETURN(strictLocalize) {
  return strictLocalize({
    id: "9FSbe7",
    defaultMessage: [{
      "type": 0,
      "value": "Let op: verwerk beschadigde artikelen niet als een ‘retourzending’ om te voorkomen dat ze op een later tijdstip in rekening worden gebracht."
    }]
  });
};
export var TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE = function TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize) {
  return strictLocalize({
    id: "xNgrP9",
    defaultMessage: [{
      "type": 0,
      "value": "Btw, accijnzen en andere kosten worden niet gedekt door Faire."
    }]
  });
};
export var getReportItemsOrRequestExtensionCTA = function getReportItemsOrRequestExtensionCTA(context, strictLocalize) {
  var brandOrder = context.brandOrder,
    shippingContext = context.shippingContext;
  var deliveredAt = getDeliveredAtDateFromIAContext(context);
  if (!brandOrder || !shippingContext || !deliveredAt) {
    return undefined;
  }
  return orderCanBeReportedBasedOnDeliveryDate(deliveredAt) ? ReportItemsCTA(strictLocalize) : RequestExtensionCTA(strictLocalize);
};
export var getVerifyAccountCTA = function getVerifyAccountCTA(_context, strictLocalize) {
  return VerifyAccountCTA(strictLocalize);
};
export var getGoToFairePosCTA = function getGoToFairePosCTA(_context, strictLocalize) {
  return GoToFairePosCTA(strictLocalize);
};
export var getViewOrderInvoiceCTA = function getViewOrderInvoiceCTA(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return undefined;
  }
  return ViewOrderInvoiceCTA(strictLocalize, brandOrder);
};
export var getViewSingleOrMultipleInvoicesCTA = function getViewSingleOrMultipleInvoicesCTA(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return ViewInvoicesCTA(strictLocalize);
  }
  return ViewOrderInvoiceCTA(strictLocalize, brandOrder);
};
export var getViewAndUpdatePaymentMethodsCTA = function getViewAndUpdatePaymentMethodsCTA(_context, strictLocalize) {
  return ViewOrUpdatePaymentMethodsCTA(strictLocalize);
};
export var getGoToBrandReferralsCTA = function getGoToBrandReferralsCTA(_context, strictLocalize) {
  return GoToBrandReferralsCTA(strictLocalize);
};